module.exports = __webpack_public_path__ + "img/hero-sp.cb9ec285.webp";